import {useState, useContext, useEffect} from "react";
import {ApplicationContext} from "../../Provider/ApplicationProvider";
import List from "../List";
import Table2 from "../Table2";
import {Ajax} from "../../Service/ajax";
import {ClipLoader} from "react-spinners";
import {useNavigate} from "react-router-dom";
import Swal from "sweetalert2";
export default function SubscriptionPlanForm({title}){
    const {selectedInfos,selectedOptions}=useContext(ApplicationContext);
    const application=JSON.parse(sessionStorage.getItem("application"));
    const navigate = useNavigate();
    const [options,setOptions]=useState([]);
    const [loading, setLoading] = useState(false);
    const [informations,setInformations]=useState([]);
    const trf = sessionStorage.getItem("trf");
    const session = sessionStorage.getItem("session");

    const [isChecked, setIsChecked] = useState(false);
    const [isSecondDivVisible, setIsSecondDivVisible] = useState(false);
    const [isThirdDivVisible, setIsThirdDivVisible] = useState(false);

    const handleCheckboxChange = (e) => {
        setIsChecked(e.target.checked);
        if (!e.target.checked) {
            setIsSecondDivVisible(false);
            setIsThirdDivVisible(false);
        }else{
            setIsSecondDivVisible(true);
        }
    };

    const handleOkClick = () => {
        setIsSecondDivVisible(false);
        setIsThirdDivVisible(true);
    };

    const handleCancelClick = () => {
        setIsSecondDivVisible(false);
        setIsChecked(false);
    };

    useEffect(() => {
    }, [isChecked, isSecondDivVisible, isThirdDivVisible]);


    const [subscriptionsPlan, setSubscriptionPlan] = useState({
        title: "N/D",
        periodicity: "N/D",
        price: 0.0,
        devise: "N/D",
        options: [],
        informations: [],
    });
    const [titleInput, setTitleInput] = useState('');
    const [periodicityInput, setPeriodicityInput] = useState('DAILY');
    const [priceInput, setPriceInput] = useState(0.0);
    const [deviseInput, setDeviseInput] = useState('CDF');
    const [categoryInput, setCategoryInput] = useState('individual');

    const handleSave = async () => {
        const updatedPlan = {
            title: titleInput || subscriptionsPlan.title,
            periodicity: periodicityInput || subscriptionsPlan.periodicity,
            price: priceInput || subscriptionsPlan.price,
            devise: deviseInput || subscriptionsPlan.devise,
            options: selectedOptions,
            informations: selectedInfos,
            category: isChecked && isThirdDivVisible ? categoryInput : "default",
        };
        try {
            setLoading(true);
            const {data}=await Ajax.postRequest(`/api/v1/sub/application/${application.id}/subscription/create?eval=false`,updatedPlan);
            if(data.error){
                sessionStorage.setItem("error",data.error);
                sessionStorage.setItem("message", data.message);
                window.location.reload();
            }else{
                sessionStorage.setItem("success","Pack d'abonnement crée avec succès");
                window.location.reload();
            }
            window.location.reload();
        } catch (error) {
            Swal.fire({
                title: 'Error!',
                text:`Oups! Une erreur s'est produite, veuillez reesayer plus tard.`,
                icon: 'error',
                confirmButtonText: 'OK',
                customClass: {
                    popup: 'custom-popup',
                    confirmButton: 'custom-button'
                },
                timer: 5000
            });
        }finally {
            setLoading(false)
        }
    };
    const handleAbort = () =>{
        setOptions([]);
        setInformations([]);
    }
    useEffect(() => {
        const fetchData = async (trf_id) => {
            try {
                let isActive ;
                isActive = JSON.parse(trf).status === "ACTIVE";
                const optionsResponse = await Ajax.getRequest(`/api/v1/sub/application/${application.id}/options/retrieve`);
                const { data: optionsData } = optionsResponse;
                setOptions(optionsData.object);

                const informationsResponse = await Ajax.getRequest(`/api/v1/sub/application/${application.id}/informations/retrieve`);
                const { data: informationsData } = informationsResponse;
                setInformations(informationsData.object);
            } catch (error) {
                navigate("/error-page", { state: { errorCode: error.response.status } });
            }
        };
        if (session && trf) {
            fetchData(JSON.parse(trf).id);
        }else{
            navigate('/');
        }

    }, [application.id,session]);
    return(
        <div className="modal-content">
            <div className="modal-header">
                <h5 className="modal-title" id="modalFullTitle">{title}</h5>
                <button
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                ></button>
            </div>
            <div className="modal-body">
                <div className="col-md-12">
                    <div className="row">
                        <div className="col-md-4">
                            <div className="row">
                                <div className="col-12">
                                    <div className="card mb-4">
                                        <h5 className="card-header">Ajouter un abonnement</h5>
                                        <div className="card-body demo-vertical-spacing demo-only-element">
                                            <div className="input-group">
                                                <span className="input-group-text col-3" id="title">Titre</span>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="Titre du pack"
                                                    aria-label="Title"
                                                    aria-describedby="title"
                                                    value={titleInput}
                                                    onChange={(e) => setTitleInput(e.target.value)}
                                                />
                                            </div>
                                            <div className="input-group">
                                                <label className="input-group-text col-3"
                                                       htmlFor="period">Périodicité</label>
                                                <select className="form-select" id="period"
                                                        value={periodicityInput}
                                                        onChange={(e) => setPeriodicityInput(e.target.value)}
                                                >
                                                    <option selected value="DAILY">Jour</option>
                                                    <option value="WEEKLY">Semaine</option>
                                                    <option value="MONTHLY">Mois</option>
                                                    <option value="ANNUAL">Année</option>
                                                    <option value="PERMANENT">Permanent</option>
                                                </select>
                                            </div>
                                            <div>
                                                {/* Premier div avec la case à cocher */}
                                                <div className={"mb-2"}>
                                                    <label>
                                                        <input
                                                            type="checkbox"
                                                            checked={isChecked}
                                                            onChange={handleCheckboxChange}
                                                            className={"me-2"}
                                                        />
                                                        Activer la gestion des catégories
                                                    </label>
                                                </div>

                                                {/* Deuxième div (affiché si la case est cochée) */}
                                                {isChecked && isSecondDivVisible && (
                                                    <div className={"mb-2"}>
                                                        <p>
                                                            La catégorie vous permet d’organiser vos packs d'abonnement en
                                                            différents groupes selon leurs caractéristiques ou usages
                                                            spécifiques. Par défaut, tous les packs d'abonnements sont
                                                            considérés comme étant personnels. Cependant, cette fonctionnalité
                                                            vous offre la possibilité de les regrouper dans des catégories
                                                            distinctes pour mieux structurer et gérer vos offres, en fonction
                                                            des besoins variés de vos utilisateurs.
                                                        </p>
                                                        <button className="btn btn-netikash me-2" onClick={handleOkClick}>
                                                            OK, j'ai compris
                                                        </button>
                                                        <button className="btn btn-danger" onClick={handleCancelClick}>
                                                            Annuler
                                                        </button>
                                                    </div>
                                                )}

                                                {/* Troisième div avec le select (affiché en fonction du clic sur "OK, j'ai compris") */}
                                                {isChecked && isThirdDivVisible && (
                                                    <div className="input-group">
                                                        <label
                                                            className="input-group-text col-3"
                                                            htmlFor="category"
                                                        >
                                                            Catégorie
                                                        </label>
                                                        <select className="form-select" id="category"
                                                                value={categoryInput}
                                                                onChange={(e) => setCategoryInput(e.target.value)}
                                                        >
                                                            <option selected value="individual">
                                                                Personnel
                                                            </option>
                                                            <option value="company">Entreprise</option>
                                                        </select>
                                                    </div>
                                                )}
                                            </div>

                                            <div className="input-group">
                                                <span className="input-group-text col-3" id="price">Prix</span>
                                                <input
                                                    type="number"
                                                    className="form-control"
                                                    placeholder="Prix abonnement"
                                                    aria-label="price"
                                                    aria-describedby="price"
                                                    value={priceInput}
                                                    onChange={(e) => setPriceInput(parseFloat(e.target.value))}
                                                />
                                            </div>
                                            <div className="input-group">
                                                <label className="input-group-text col-3"
                                                       htmlFor="currency">Devise</label>
                                                <select className="form-select" id="currency"
                                                        value={deviseInput}
                                                        onChange={(e) => setDeviseInput(e.target.value)}
                                                >
                                                    <option selected value="CDF">CDF</option>
                                                    {/*<option value="USD">USD</option>*/}
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-8">
                            <div className="row">
                                <div className="card mb-4">
                                    <List title={"Informations"} list={informations}/>
                                </div>
                                <div className="card mb-4">
                                    <Table2 title={"Options"} list={options}/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="modal-footer">
                <button type="button" className={`btn btn-outline-netikash ${loading ? 'disabled' : ''}`} onClick={handleAbort} data-bs-dismiss="modal">
                    Fermer
                </button>
                <button
                    type="button"
                    className={`btn btn-netikash ${loading ? 'disabled' : ''}`}
                    onClick={handleSave}
                >
                    {loading ? (
                        <ClipLoader color="#36d7b7" loading size={15}/>
                    ) : (
                        'Enregister'
                    )}
                </button>
            </div>
        </div>
    );
}
